export default {
	artistById: (id: string) => `/artist/${id}`,
	artistFanSegmentation: (id: string) => `/artists/${id}/fan-segmentation`,
	releases: (id: string) => `/artists/${id}/releases`,
	playlists: (id: string) => `/artists/${id}/playlisted`,
	topTracks: (artistId: string) => `/artists/${artistId}/top-tracks`,
	topPlaylists: (artistId: string) => `/artists/${artistId}/top-playlists`,
};
